var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6004 2.04294C18.8943 2.35579 18.1358 2.56719 17.3384 2.66274C18.1519 2.1757 18.7759 1.40279 19.0702 0.482784C18.3092 0.934354 17.4661 1.26243 16.569 1.43831C15.8502 0.673922 14.827 0.195312 13.6939 0.195312C11.5191 0.195312 9.75518 1.95921 9.75518 4.13578C9.75528 4.43742 9.78932 4.7381 9.85664 5.03214C6.58168 4.86721 3.68043 3.29863 1.73727 0.915749C1.39907 1.49921 1.20455 2.1757 1.20455 2.89613C1.20455 4.26258 1.9005 5.46928 2.95661 6.17537C2.33111 6.15544 1.71941 5.98642 1.17242 5.68237V5.7331C1.17242 7.64158 2.5296 9.23386 4.3324 9.5958C3.99412 9.68707 3.64523 9.73312 3.29485 9.73277C3.04604 9.73297 2.79776 9.70976 2.55329 9.66344C3.05472 11.2278 4.50915 12.3676 6.23331 12.3981C4.88456 13.4551 3.18579 14.085 1.34069 14.085C1.02275 14.085 0.709029 14.0664 0.400391 14.03C2.14402 15.1488 4.21403 15.7999 6.43792 15.7999C13.6846 15.7999 17.6462 9.79785 17.6462 4.59239C17.6462 4.42329 17.642 4.25245 17.6344 4.08335C18.4039 3.52693 19.0719 2.8344 19.5987 2.04546L19.6004 2.04294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.560e18e8725ccd372254e28916dbc114.svg";
export { ForwardRef as ReactComponent };